import Overview from './overview.vue';

export const componentMap = {
	overview: Overview,
	full: Overview // 组件路径兼容，但实际的访问入口已拦截
};
